// JsFromRoutes CacheKey fee3855d9b2c2cbaa28b5d83b6a71ec7
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/axios'

export default {
  create: definePathHelper('post', '/contract_summaries/export'),
}
